import { Box, Button, Flex, HStack, Icon, IconButton, Image, Skeleton, Spacer, Text, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import Medico from '../../../images/modalPsicologo.svg';
import useModelPagamentoTelemed from './useModelPagamentoTelemed';
import { ArrowBackIcon, CalendarIcon, WarningTwoIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import Plano from '../../Cadastro/Plano';
import { FaTimes } from 'react-icons/fa';
import ChildHeader from '../Main/ChildHeader';

function PagamentoTelemedicina() {
  const {
    valor,
    loading,
    assinante,
    tipoAtendimento,
    valorCobrar,
    pago,
    metadataTelemed,
    valorProc,
    user,
    isCreditoPago,
    setUser,
    clientePendente,
    fetchVoucherTelemedicina,
    errorVoucher,
    voucherValido,
    fetchVincularVoucher,
    setVoucherValido,
    setErrorVoucher,
  } = useModelPagamentoTelemed();
  const [imageLoading, setImageLoading] = useState(true);
  const navigate = useNavigate();
  const [planoLoaded, setPlanoLoaded] = useState(user.id_plano ? 0 : null);
  const [voucher, setVoucher] = useState('');
  let descontoPercent = null;
  let valorComDesconto = null;
  let valorEconomizado = null;

  if (voucherValido?.percent) {
    descontoPercent = voucherValido.percent;

    if (valorCobrar?.valor) {
      valorComDesconto = valorCobrar.valor - (valorCobrar.valor * descontoPercent) / 100;

      valorEconomizado = valorCobrar.valor - valorComDesconto;
    }
  }

  const removerVoucher = () => {
    setVoucher('');
    setVoucherValido(null);
    setErrorVoucher(null);

    setUser((prevUser) => ({
      ...prevUser,
      voucher: null,
    }));
  };

  const isVoucherGratis = descontoPercent === 100 || valorComDesconto === 0;

  if (pago) {
    return (
      <>
        <VStack bg="gray.50" minH="100vh" w="100vw" p={4}>
          <VStack w="100%" maxW="md" bg="white" borderRadius="2xl" p={6} spacing={6} boxShadow="lg">
            <Box w={{ base: '35%', md: '25%' }} mx="auto" mt={10}>
              <Image src={Medico} alt="Médico(a)" w="100%" borderRadius="full" />
            </Box>

            {!assinante && (
              <>
                <Flex
                  bg="red.500"
                  color="white"
                  px={4}
                  py={1}
                  borderRadius="full"
                  align="center"
                  justify="center"
                  fontSize="sm"
                  fontWeight="bold"
                  w="fit-content"
                  mx="auto"
                >
                  Sem assinatura
                </Flex>
              </>
            )}

            <VStack spacing={3} w="100%">
              <Text fontSize="xl" color="#424242" fontWeight="bold" textAlign="center">
                Seu pagamento foi identificado!
              </Text>

              <Text fontSize="sm" color="gray.600" textAlign="center">
                Você pagou{' '}
                <strong>
                  R${' '}
                  {Number(user.credito_valor).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </strong>{' '}
                por esta consulta.
              </Text>

              {!assinante && (
                <>
                  <Text fontSize="sm" color="#2A918A" fontWeight="semibold" textAlign="center">
                    Assine um de nossos planos para economizar nas próximas consultas!
                  </Text>
                </>
              )}
            </VStack>

            <Box
              borderRadius="lg"
              p={4}
              w="100%"
              border="1px solid #FFCBCF"
              bg="radial-gradient(circle at center, #FFD6DA 0%, #FFE9EC 55%, #FFF3F4 100%)"
              boxShadow="sm"
            >
              <Text fontSize="sm" color="red.600">
                Atenção: seu crédito será utilizado para esta consulta e, em caso de desistência, será necessário um novo pagamento
              </Text>
            </Box>

            <Button
              w="100%"
              bg="#5AB2AE"
              color="white"
              borderRadius="full"
              py={6}
              fontSize="lg"
              fontWeight="bold"
              boxShadow="md"
              _hover={{ bg: '#4AA09C' }}
              onClick={() => {
                setUser((prevUser) => ({
                  ...prevUser,
                  paga_telemedicina: false,
                }));

                if (user.agendamento_posterior_id) {
                }

                if (tipoAtendimento === 'clinico') {
                  navigate('/aviso-pre-atendimento/', {
                    state: { titulo: 'Pronto Atendimento', tela: '/medico-agora/', pediatra: false },
                  });
                  return;
                }

                if (tipoAtendimento === 'pediatra') {
                  navigate('/aviso-pre-atendimento/', {
                    state: {
                      titulo: 'Pronto Atendimento Pediátrico',
                      tela: '/medico-agora/',
                      pediatra: true,
                    },
                  });
                  return;
                }
                if (tipoAtendimento === 'veterinario') {
                  navigate('/aviso-pre-atendimento/', {
                    state: { titulo: 'Telemedicina Pet', tela: '/telepet/termos/', pediatra: false },
                  });
                }
              }}
            >
              Seguir para a consulta
            </Button>
            <Button
              width="100%"
              bg="#F5F5F5"
              color="#616161"
              leftIcon={<Icon as={ArrowBackIcon} />}
              _hover={{ bg: 'gray.100' }}
              size="md"
              onClick={() => navigate(-1)}
              borderRadius="full"
              border="1px solid 616161"
            >
              Voltar
            </Button>
          </VStack>
        </VStack>
      </>
    );
  }

  if (assinante && !pago) {
    return (
      <>
        <VStack bg="#5AB2AE" minH="100vh" w="100vw" spacing={0} p={4}>
          <Flex w="100%" maxW="md" align="center" mb={4}>
            <IconButton h={10} aria-label="Voltar" icon={<ArrowBackIcon />} variant="ghost" color="#5AB2AE" onClick={() => navigate(-1)} />
          </Flex>

          <VStack w="100%" maxW="md" bg="white" borderRadius="2xl" p={6} spacing={6} boxShadow="lg">
            <Box position="relative" w={{ base: '35%', md: '25%' }}>
              {imageLoading && (
                <Flex justify="center" align="center" w="100%" h="100%" position="absolute" top={0} left={0} zIndex={1}>
                  <Box
                    as="span"
                    w="40px"
                    h="40px"
                    borderWidth="4px"
                    borderStyle="solid"
                    borderColor="#5AB2AE transparent #5AB2AE transparent"
                    borderRadius="50%"
                    animation="spin 1s linear infinite"
                  />
                </Flex>
              )}

              <Image
                src={Medico}
                alt="Médico(a)"
                w="100%"
                borderRadius="full"
                onLoad={() => setImageLoading(false)}
                style={imageLoading ? { visibility: 'hidden' } : {}}
              />
            </Box>

            <VStack spacing={1}>
              <Text color="#5AB2AE" fontWeight="bold" fontSize="xl">
                Agende seu atendimento
              </Text>
              <Text color="gray.600" fontSize="sm" textAlign="center">
                Para continuar com o agendamento, realize o pagamento do atendimento de telemedicina.
              </Text>
            </VStack>

            <Flex justify="space-between" w="100%" p={4} borderRadius="lg" bg="gray.50">
              <Text fontSize="sm" color="gray.600">
                Valor do atendimento
                <br />
                <strong>
                  {tipoAtendimento === 'clinico' && 'Clínico Geral'}
                  {tipoAtendimento === 'pediatra' && 'Pediatra'}
                  {tipoAtendimento === 'veterinario' && 'Veterinário'}
                </strong>
              </Text>

              <Skeleton isLoaded={!loading}>
                {descontoPercent ? (
                  <VStack spacing={1} align="flex-start">
                    <Text fontSize="xl" fontWeight="bold" color="#237973">
                      R${' '}
                      {Number(valorComDesconto).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Text>

                    <Text fontSize="sm" color="gray.500" textDecoration="line-through">
                      R${' '}
                      {Number(valorCobrar.valor).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Text>
                  </VStack>
                ) : (
                  <Text fontSize="lg" fontWeight="bold" color="gray.700">
                    R${' '}
                    {Number(valorCobrar.valor).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Text>
                )}
              </Skeleton>
            </Flex>

            {descontoPercent && (
              <Box w="100%" mb={2} textAlign="center">
                <Text color="#237973" fontWeight="bold" fontSize="md">
                  Desconto aplicado: {parseInt(descontoPercent, 10)}%
                </Text>
                {valorEconomizado !== null && (
                  <Text color="#237973" fontWeight="normal" fontSize="sm">
                    Você economizou R$ {valorEconomizado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </Text>
                )}
              </Box>
            )}

            <Box
              borderRadius="lg"
              p={4}
              w="100%"
              border="1px solid #FFCBCF"
              bg="radial-gradient(circle at center, #FFD6DA 0%, #FFE9EC 55%, #FFF3F4 100%)"
              boxShadow="sm"
            >
              <HStack align="flex-start" spacing={3}>
                <VStack align="flex-start" spacing={1}>
                  <HStack>
                    <Icon as={WarningTwoIcon} w={6} h={6} color="#D62422" mt={1} />
                    <Text fontWeight="bold" color="#D62422">
                      Atenção
                    </Text>
                  </HStack>

                  <Text color="#D62422" fontSize="sm">
                    Você terá até 24h após a confirmação do pagamento para realizar seu atendimento. Após esse período, será necessário realizar um
                    novo pagamento.
                  </Text>
                </VStack>
              </HStack>
            </Box>
            {tipoAtendimento === 'clinico' && (
              <Box w="100%" mb={4}>
                <Text fontSize="sm" fontWeight="600" color="#5AB2AE" mb={1}>
                  Voucher
                </Text>

                <HStack spacing={2} align="center">
                  <Box flex="1" position="relative">
                    <input
                      type="text"
                      id="voucher"
                      name="voucher"
                      value={voucher}
                      onChange={(e) => setVoucher(e.target.value.toUpperCase())}
                      placeholder="Voucher de consulta"
                      style={{
                        padding: '10px 36px 10px 12px',
                        width: '100%',
                        borderRadius: 10,
                        border: '1px solid #2A918A',
                        outline: 'none',
                        fontSize: 14,
                      }}
                      onFocus={(e) => {
                        e.target.style.boxShadow = '0 0 0 2px rgba(42, 145, 138, 0.35)';
                      }}
                      onBlur={(e) => {
                        e.target.style.boxShadow = 'none';
                      }}
                    />

                    {voucher.trim() !== '' && (
                      <Box
                        position="absolute"
                        top="50%"
                        right="10px"
                        transform="translateY(-50%)"
                        cursor="pointer"
                        onClick={removerVoucher}
                        color="red.500"
                        fontWeight="bold"
                        fontSize="14px"
                        _hover={{ opacity: 0.7 }}
                      >
                        ✕
                      </Box>
                    )}
                  </Box>

                  <Button
                    bg="#2A918A"
                    color="white"
                    _hover={{ bg: '#5AB2AE' }}
                    _active={{ bg: '#1F655D' }}
                    borderRadius="full"
                    minW="96px"
                    h="40px"
                    isDisabled={voucher.trim() === ''}
                    isLoading={loading}
                    onClick={() => fetchVoucherTelemedicina(voucher)}
                  >
                    Aplicar
                  </Button>
                </HStack>
              </Box>
            )}

            {errorVoucher && (
              <Text color="red.500" fontSize="sm" textAlign="center">
                {errorVoucher}
              </Text>
            )}

            <Button
              leftIcon={<CalendarIcon />}
              bg="#5AB2AE"
              color="white"
              w="100%"
              borderRadius="full"
              py={6}
              fontSize="lg"
              fontWeight="bold"
              boxShadow="md"
              _hover={{ bg: '#4AA09C' }}
              isDisabled={
                descontoPercent
                  ? valorComDesconto === undefined ||
                    valorComDesconto === null ||
                    isNaN(valorComDesconto) ||
                    (!isVoucherGratis && valorComDesconto <= 0)
                  : valorCobrar.valor === undefined || valorCobrar.valor === null || isNaN(valorCobrar.valor) || valorCobrar.valor <= 0
              }
              onClick={async () => {
                if (user?.voucher?.tipo === 'Assinatura') {
                  setUser((prevUser) => ({
                    ...prevUser,
                    voucher: null,
                  }));
                }
                if (user.loggedIn === false) {
                  navigate('/login');
                  return;
                }

                if (voucher) {
                  await fetchVincularVoucher(voucher, valorComDesconto, valorCobrar.valor);
                }

                if (voucher && voucherValido && (descontoPercent === 100 || valorComDesconto < 1)) {
                  if (tipoAtendimento === 'clinico') {
                    navigate('/aviso-pre-atendimento/', {
                      state: { titulo: 'Pronto Atendimento', tela: '/medico-agora/', pediatra: false },
                    });
                    return;
                  }

                  if (tipoAtendimento === 'pediatra') {
                    navigate('/aviso-pre-atendimento/', {
                      state: {
                        titulo: 'Pronto Atendimento Pediátrico',
                        tela: '/medico-agora/',
                        pediatra: true,
                      },
                    });
                    return;
                  }
                  if (tipoAtendimento === 'veterinario') {
                    navigate('/aviso-pre-atendimento/', {
                      state: { titulo: 'Telemedicina Pet', tela: '/telepet/termos/', pediatra: false },
                    });
                  }
                  return;
                }

                navigate('/pagamentos', {
                  state: {
                    value: user.username,
                    name: user?.name,
                    telemedPaga: user?.allowsTelemedicina?.paga_telemedicina,
                    parcelsActive: true,
                    valor_telemedicina: valorCobrar.valor,
                    valor:
                      valorComDesconto !== null && valorComDesconto !== undefined && valorComDesconto >= 1 ? valorComDesconto : valorCobrar.valor,
                    expiration_pix_in_min: 5,
                    service: 'credit',
                    navig_to: '/alerts/sucesso/telemedicina2/',
                    solicitacao: false,
                    valor_assinante:
                      tipoAtendimento === 'clinico'
                        ? valor?.prontoAtendimento?.valor_clinico_assinante
                        : tipoAtendimento === 'pediatra'
                          ? valor?.prontoAtendimento?.valor_pediatra_assinante
                          : valor?.prontoAtendimento?.valor_veterinario_assinante,
                    frequenciaText:
                      tipoAtendimento === 'clinico'
                        ? 'Telemedicina Clínico Geral'
                        : tipoAtendimento === 'pediatra'
                          ? 'Telemedicina Pediatra'
                          : 'Telemedicina Veterinário',
                    item: [
                      {
                        nome: user?.name,
                        tipo: tipoAtendimento,
                        username: user?.username,
                      },
                    ],
                    ...(voucherValido && {
                      voucher: { tipo: 'Telemedicina', voucher: voucherValido },
                      valorEconomizado,
                      valor_com_desconto: valorComDesconto,
                    }),
                  },
                });
              }}
            >
              Realizar pagamento
            </Button>
            <Button
              width="100%"
              bg="#F5F5F5"
              color="#616161"
              leftIcon={<Icon as={ArrowBackIcon} />}
              _hover={{ bg: 'gray.100' }}
              size="md"
              onClick={() => navigate(-1)}
              borderRadius="full"
              border="1px solid 616161"
            >
              Voltar
            </Button>
          </VStack>
        </VStack>
      </>
    );
  }

  if (!assinante && !pago) {
    return (
      <>
        <Box textAlign={'center'} alignItems={'center'} w="100%" display="flex" flexDirection="column" minH="100vh" pb={10}>
          {!clientePendente && (
            <>
              <Box w="100%" maxW="480px" minH="520px">
                <Plano header={true} telemedicina={true} onLoaded={(menorValor) => setPlanoLoaded(menorValor)} />
              </Box>
            </>
          )}

          {clientePendente && <ChildHeader />}
          {planoLoaded !== null && (
            <>
              <Box
                border="1px solid #F5F5F5"
                borderRadius="20px"
                p={5}
                boxShadow="sm"
                m={4}
                textAlign="center"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
              >
                <VStack align="center" spacing={4} w="100%">
                  <Box w="100%" display="flex" justifyContent="center">
                    <HStack borderRadius="0.8em" p={2} spacing="6px" align="center" bg="#D62422" color="white" justifyContent="center" w="55%">
                      <Text fontSize="sm" fontWeight="bold">
                        Sem assinatura
                      </Text>
                    </HStack>
                  </Box>
                  <HStack w="100%" justifyContent="center">
                    <VStack spacing={1} align="center">
                      <HStack align="flex-end" spacing={2}>
                        <Text fontSize="4xl" fontWeight="bold" color={descontoPercent ? '#237973' : '#6C6C6C'} lineHeight="1">
                          R${' '}
                          {valorCobrar?.valor != null && !isNaN(valorCobrar.valor)
                            ? Number(descontoPercent ? valorComDesconto : valorCobrar.valor).toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : '0,00'}
                        </Text>

                        <Text fontSize="md" color="#9E9E9E" fontWeight="normal" mb="1">
                          por consulta
                        </Text>
                      </HStack>
                      {voucherValido && descontoPercent && (
                        <>
                          <Text fontSize="lg" color="gray.400" textDecoration="line-through">
                            R${' '}
                            {Number(valorCobrar.valor).toLocaleString('pt-BR', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Text>
                        </>
                      )}
                    </VStack>
                  </HStack>

                  {descontoPercent && (
                    <Box w="100%" mb={2} textAlign="center">
                      <Text color="#237973" fontWeight="bold" fontSize="md">
                        Desconto aplicado: {parseInt(descontoPercent, 10)}%
                      </Text>
                      {valorEconomizado !== null && (
                        <Text color="#237973" fontWeight="normal" fontSize="sm">
                          Você economizou R$ {valorEconomizado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </Text>
                      )}
                    </Box>
                  )}
                  <VStack align="center" spacing={3} textAlign="center" w="100%">
                    {['Sem descontos', 'Sem benefícios extras', 'Preço cheio sempre'].map((item) => (
                      <Box key={item} display="flex" alignItems="center" justifyContent="center" w="100%">
                        <Text color="#3A3A3A" textAlign="center" display="flex" alignItems="center" justifyContent="center" w="100%" gap={2}>
                          <Icon as={FaTimes} color="#D62422" mt={1} boxSize={6} />
                          {item}
                        </Text>
                      </Box>
                    ))}
                  </VStack>

                  <Box
                    w="100%"
                    bg="#F0FBFA"
                    border="1px solid #B6D5D4"
                    borderRadius="12px"
                    p={3}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text fontSize="sm" color="#3A3A3A" textAlign="center" w="100%">
                      Após a confirmação do pagamento, você terá até{' '}
                      <Box as="span" fontWeight="bold" color="#2A918A" display="inline-block" textAlign="center" minWidth="32px">
                        24h
                      </Box>{' '}
                      para realizar seu atendimento.
                    </Text>
                  </Box>
                  {tipoAtendimento === 'clinico' && (
                    <Box w="100%" mb={4}>
                      <Text fontSize="sm" fontWeight="600" color="#5AB2AE" mb={1}>
                        Voucher
                      </Text>

                      <HStack spacing={2} align="center">
                        <Box flex="1" position="relative">
                          <input
                            type="text"
                            id="voucher"
                            name="voucher"
                            value={voucher}
                            onChange={(e) => setVoucher(e.target.value.toUpperCase())}
                            placeholder="Voucher de consulta"
                            style={{
                              padding: '10px 36px 10px 12px',
                              width: '100%',
                              borderRadius: 10,
                              border: '1px solid #2A918A',
                              outline: 'none',
                              fontSize: 14,
                            }}
                            onFocus={(e) => {
                              e.target.style.boxShadow = '0 0 0 2px rgba(42, 145, 138, 0.35)';
                            }}
                            onBlur={(e) => {
                              e.target.style.boxShadow = 'none';
                            }}
                          />

                          {voucher.trim() !== '' && (
                            <Box
                              position="absolute"
                              top="50%"
                              right="10px"
                              transform="translateY(-50%)"
                              cursor="pointer"
                              onClick={removerVoucher}
                              color="red.500"
                              fontWeight="bold"
                              fontSize="14px"
                              _hover={{ opacity: 0.7 }}
                            >
                              ✕
                            </Box>
                          )}
                        </Box>

                        <Button
                          bg="#2A918A"
                          color="white"
                          _hover={{ bg: '#5AB2AE' }}
                          _active={{ bg: '#1F655D' }}
                          borderRadius="full"
                          minW="96px"
                          h="40px"
                          isDisabled={voucher.trim() === ''}
                          isLoading={loading}
                          onClick={() => fetchVoucherTelemedicina(voucher)}
                        >
                          Aplicar
                        </Button>
                      </HStack>
                    </Box>
                  )}

                  {errorVoucher && (
                    <Text color="red.500" fontSize="sm" textAlign="center">
                      {errorVoucher}
                    </Text>
                  )}
                  <Button
                    w="100%"
                    bg="#5AB2AE"
                    color="white"
                    borderRadius="full"
                    size="lg"
                    fontWeight="bold"
                    _hover={{ bg: '#237973' }}
                    isDisabled={
                      descontoPercent
                        ? valorComDesconto === undefined ||
                          valorComDesconto === null ||
                          isNaN(valorComDesconto) ||
                          (!isVoucherGratis && valorComDesconto <= 0)
                        : valorCobrar.valor === undefined || valorCobrar.valor === null || isNaN(valorCobrar.valor) || valorCobrar.valor <= 0
                    }
                    onClick={async () => {
                      if (user?.voucher?.tipo === 'Assinatura') {
                        setUser((prevUser) => ({
                          ...prevUser,
                          voucher: null,
                        }));
                      }
                      if (!user.loggedIn) {
                        navigate('/cadastro', {
                          state: {
                            telemedicina: {
                              backTo: '/pagamentos',
                              tipoAtendimento: tipoAtendimento,
                              telemedicina: true,
                              valor_telemedicina: valorCobrar.valor,
                              valor: valorComDesconto && valorComDesconto > 0 ? valorComDesconto : valorCobrar.valor,
                              frequenciaText:
                                tipoAtendimento === 'clinico'
                                  ? 'Telemedicina Clínico Geral'
                                  : tipoAtendimento === 'pediatra'
                                    ? 'Telemedicina Pediatra'
                                    : 'Telemedicina Veterinário',
                              service: 'credit',
                              navig_to: '/alerts/sucesso/telemedicina2/',
                              ...(voucherValido && {
                                voucher: { tipo: 'Telemedicina', voucher: voucherValido },
                                valorEconomizado,
                                valor_com_desconto: valorComDesconto,
                              }),
                              valor_assinante:
                                tipoAtendimento === 'clinico'
                                  ? valor?.prontoAtendimento?.valor_clinico_assinante
                                  : tipoAtendimento === 'pediatra'
                                    ? valor?.prontoAtendimento?.valor_pediatra_assinante
                                    : valor?.prontoAtendimento?.valor_veterinario_assinante,
                            },
                          },
                        });
                        return;
                      }
                      if (voucher) {
                        await fetchVincularVoucher(voucher, valorComDesconto, valorCobrar.valor);
                      }

                      if (voucher && voucherValido && (descontoPercent === 100 || valorComDesconto < 1)) {
                        if (tipoAtendimento === 'clinico') {
                          navigate('/aviso-pre-atendimento/', {
                            state: { titulo: 'Pronto Atendimento', tela: '/medico-agora/', pediatra: false },
                          });
                          return;
                        }

                        if (tipoAtendimento === 'pediatra') {
                          navigate('/aviso-pre-atendimento/', {
                            state: {
                              titulo: 'Pronto Atendimento Pediátrico',
                              tela: '/medico-agora/',
                              pediatra: true,
                            },
                          });
                          return;
                        }
                        if (tipoAtendimento === 'veterinario') {
                          navigate('/aviso-pre-atendimento/', {
                            state: { titulo: 'Telemedicina Pet', tela: '/telepet/termos/', pediatra: false },
                          });
                        }
                        return;
                      }

                      navigate('/pagamentos', {
                        state: {
                          value: user.username,
                          name: user?.name,
                          telemedPaga: user?.allowsTelemedicina?.paga_telemedicina,
                          parcelsActive: true,
                          valor_telemedicina: valorCobrar.valor,
                          valor:
                            valorComDesconto !== null && valorComDesconto !== undefined && valorComDesconto !== 0
                              ? valorComDesconto
                              : valorCobrar.valor,
                          expiration_pix_in_min: 5,
                          service: 'credit',
                          navig_to: '/alerts/sucesso/telemedicina2/',
                          solicitacao: false,
                          valor_assinante:
                            tipoAtendimento === 'clinico'
                              ? valor?.prontoAtendimento?.valor_clinico_assinante
                              : tipoAtendimento === 'pediatra'
                                ? valor?.prontoAtendimento?.valor_pediatra_assinante
                                : valor?.prontoAtendimento?.valor_veterinario_assinante,
                          frequenciaText:
                            tipoAtendimento === 'clinico'
                              ? 'Telemedicina Clínico Geral'
                              : tipoAtendimento === 'pediatra'
                                ? 'Telemedicina Pediatra'
                                : 'Telemedicina Veterinário',
                          item: [
                            {
                              nome: user?.name,
                              tipo: tipoAtendimento,
                              username: user?.username,
                            },
                          ],
                          ...(voucherValido && {
                            voucher: { tipo: 'Telemedicina', voucher: voucherValido },
                            valorEconomizado,
                            valor_com_desconto: valorComDesconto,
                          }),
                        },
                      });
                    }}
                  >
                    Realizar pagamento
                  </Button>
                </VStack>
              </Box>
              {!user.id_plano && (
                <>
                  <Box w="100%" display="flex" justifyContent="center" mt={2} mb={1}>
                    <Box
                      w={{ base: '95%', md: '70%', lg: '50%' }}
                      maxW="500px"
                      mx="auto"
                      bg="#f9f2e2"
                      p={2}
                      borderRadius="1.2em"
                      border="1px solid #eed29d"
                      textAlign="center"
                      boxShadow="0 2px 16px 0 rgba(44,44,44,0.10)"
                    >
                      <Text fontSize="sm" color="#616161" lineHeight="shorter">
                        Com apenas{' '}
                        <Box as="span" fontWeight="bold" color="#2A918A">
                          2 consultas/mês
                        </Box>{' '}
                        você já economiza!
                      </Text>

                      <Text fontSize="sm" color="#616161" mt={1}>
                        Planos a partir de{' '}
                        <Box as="span">
                          {planoLoaded != null
                            ? planoLoaded.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })
                            : '--'}
                          /mês
                        </Box>
                      </Text>
                    </Box>
                  </Box>
                </>
              )}
            </>
          )}

          <Spacer />
        </Box>
      </>
    );
  }

  return null;
}

export default PagamentoTelemedicina;
